
// This file contains only the core functions, configurable settings are handled by an_analyzify_settings.liquid
try {
  window.dataLayer = window.dataLayer || [];
      analyzify.log('Analyzify settings loadeddd', 'an_analyzify_settings');
  
  if (!window.analyzify) {
    console.warn('Analyzify object not found. Make sure an_analyzify_settings.liquid is loaded before this file.');
    window.analyzify = {};
  }
  // Add core functions to existing analyzify object
  window.analyzify = {
    ...window.analyzify,
    analyzify_version: "Custom 4.1",
    
    cart_attributes: window.analyzify.cart_attributes || {},
    extractedCartDataObj: {},
    unformattedCartDataObj: {},
    pageEventParams: {},
    breadcrumbCategories: {},
    breadcrumbCategoriesItem: {},

    getQueryParam: function (name) {
      try {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(name) || null;
        } catch (error) {
          console.error(`Error retrieving query parameter "${name}":`, error);
          return null;
        }
    },

    buildEventLocation: function(handle, pageType) {
      if (pageType === 'page' && window.location.pathname.includes('/pages/your-wishlist')) {
        pageType = 'wishlist';
      }
      return `${(handle || 'no_handle')}:${pageType}`;
    },

    extractPageNameFromUrl: function() {
      try {
        const path = window.location.pathname;
        
        if (path === '/' || path === '') {
          return 'home';
        }
        
        const segments = path.split('/').filter(segment => segment && segment !== 'intl' && segment !== 'en');
        if (segments.length === 0) {
          return 'home';
        }
        
        let lastSegment = segments[segments.length - 1];
        
        if (lastSegment.startsWith('cat') && /^\d+$/.test(lastSegment.substring(3))) {
          lastSegment = segments[segments.length - 2] || lastSegment;
        }
        
        lastSegment = lastSegment.split('?')[0];
        
        return lastSegment.toLowerCase().replace(/-/g, '_');
        
      } catch (error) {
        console.error('Error extracting page name from URL:', error);
        return 'unknown';
      }
    },

    getUtmFromSessionStorage: function() {
      try {
        // First check if we have current UTM values from query parameters
        const currentUtm = {
          name: window.analyzify.getQueryParam('utm_campaign'),
          medium: window.analyzify.getQueryParam('utm_medium'),
          source: window.analyzify.getQueryParam('utm_source'),
          term: window.analyzify.getQueryParam('utm_term'),
          content: window.analyzify.getQueryParam('utm_content'),
          campaign_id: window.analyzify.getQueryParam('utm_id')
        };

        // Check if any current UTM values exist
        const hasCurrentUtm = Object.values(currentUtm).some(value => value !== null);

        if (hasCurrentUtm) {
          // Save current UTM values to session storage
          window.analyzify.sessionStorage.save("azfy_session_utm", JSON.stringify(currentUtm));
          window.analyzify.log('Saved current UTM values to session storage:', currentUtm, 'an_analyzify', 'getUtmFromSessionStorage');
          return currentUtm;
        }

        // If no current UTM values, try to get from session storage
        const sessionUtmStr = window.analyzify.sessionStorage.get("azfy_session_utm");
        if (sessionUtmStr) {
          const sessionUtm = JSON.parse(sessionUtmStr);
          window.analyzify.log('Retrieved UTM values from session storage:', sessionUtm, 'an_analyzify', 'getUtmFromSessionStorage');
          return sessionUtm;
        }

        // Return null values if nothing found
        const emptyUtm = {
          name: null,
          medium: null,
          source: null,
          term: null,
          content: null,
          campaign_id: null
        };

        window.analyzify.log('No UTM values found, returning empty:', emptyUtm, 'an_analyzify', 'getUtmFromSessionStorage');
        return emptyUtm;

      } catch (error) {
        console.error('Error extracting UTM from session storage:', error);
        return {
          name: null,
          medium: null,
          source: null,
          term: null,
          content: null,
          campaign_id: null
        };
      }
    },

    createPageEventParams: function() {
      try {
        let pageGender = "neutral"; 
        if (window.analyzify.shopify_template === "collection" || window.analyzify.shopify_template === "product") {
          pageGender = "female";
        }

        let pageName = (window.analyzify.shopify_template === "product")
            ? "pdp"
            : window.analyzify.extractPageNameFromUrl();
        
        // Get UTM values from session storage
        const utmValues = window.analyzify.getUtmFromSessionStorage();
        
        window.analyzify.pageEventParams = {
          name: utmValues.name,
          medium: utmValues.medium,
          source: utmValues.source,
          term: utmValues.term,
          content: utmValues.content,
          campaign_id: utmValues.campaign_id,
          referring_page: document.referrer,
          page_brand: "unsubscribed",
          page_gender: pageGender,
          page_name: pageName,
          page_path: document.location.pathname,
          page_location: document.location.href,
        };
        analyzify.log('Page event params created:', window.analyzify.pageEventParams, 'an_gtm', 'createPageEventParams');
      } catch (error) {
        console.error('Error creating page event params:', error);
        window.analyzify.pageEventParams = {};
      }
    },

    // Basic properties - moved from settings
    cart_attributes: null,
    eventId: null,
    cart_id: null,
    itemProps: {},
    
    // Currency will be set by settings with Liquid data 
    currency: window?.Shopify?.currency?.active || null,

    // Local storage helpers 
    checkLocalStorageSize: function() {
      try {
        let totalSize = 0;
        for (let key in localStorage) {
          if (localStorage.hasOwnProperty(key)) {
            totalSize += localStorage[key].length + key.length;
          }
        }
        
        const estimatedLimit = 5 * 1024 * 1024; // 5MB in bytes
        const usagePercentage = (totalSize / estimatedLimit) * 100;
        
        analyzify.log(`LocalStorage usage: ${totalSize} bytes (${usagePercentage.toFixed(2)}%)`, "an_analyzify", "checkLocalStorageSize");
        
        return {
          totalSize: totalSize,
          usagePercentage: usagePercentage,
          isOverLimit: usagePercentage >= 90
        };
      } catch (error) {
        analyzify.log(error, "an_analyzify", "checkLocalStorageSize");
        return { totalSize: 0, usagePercentage: 0, isOverLimit: false };
      }
    },

    resetLocalStorage: function(key) {
      try {
        if (key) {
        analyzify.log(`Resetting ${key} due to localStorage size limit`, "an_analyzify", "resetLocalStorage");
        localStorage.removeItem(key);
        analyzify.log(`${key} reset completed`, "an_analyzify", "resetLocalStorage");
      } else {
        localStorage.clear();
        analyzify.log("All localStorage reset completed", "an_analyzify", "resetLocalStorage");
      }
    } catch (error) {
      analyzify.log(error, "an_analyzify", "resetLocalStorage");
      }
    },

    saveToLocalStorage: function (key, value) {
      try {
        if (value) {
          const valueToStore = typeof value === "object" ? JSON.stringify(value) : value;
          localStorage.setItem(key, valueToStore);
        }
      } catch (error) {
        analyzify.log(error, "an_analyzify", "saveToLocalStorage");
        
        // Check localStorage size and reset if over 90%
        const sizeInfo = analyzify.checkLocalStorageSize();
        if (sizeInfo.isOverLimit) {
          analyzify.resetLocalStorage('azfy_utm_history');
          
          try {
            if (value) {
              const valueToStore = typeof value === "object" ? JSON.stringify(value) : value;
              localStorage.setItem(key, valueToStore);
              analyzify.log(`Successfully saved ${key} after localStorage reset`, "an_analyzify", "saveToLocalStorage");
            }
          } catch (retryError) {
            analyzify.log(`Failed to save ${key} even after localStorage reset`, "an_analyzify", "saveToLocalStorage");
            analyzify.log(retryError, "an_analyzify", "saveToLocalStorage");
          }
        }
      }
    },

    getFromLocalStorage: function (key) {
      try {
        const value = localStorage.getItem(key);
        return value;
      } catch (error) {
        analyzify.log(error, 'an_analyzify', 'getFromLocalStorage');
        return null;
      }
    },

    deleteFromLocalStorage: function (key) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        analyzify.log(`Error removing ${key} from localStorage:`, 'an_analyzify', 'deleteFromLocalStorage');
        analyzify.log(error, 'an_analyzify', 'deleteFromLocalStorage');
      }
    },

    sessionStorage: {
      save: function (key, value) {
        try {
          if (value) {
            const valueToStore = typeof value === "object" ? JSON.stringify(value) : value;
            sessionStorage.setItem(key, valueToStore);
          }
        } catch (error) {
          console.error(error, "an_analyzify", "sessionStorage.save");
        }
      },
      get: function (key) {
        try {
          const value = sessionStorage.getItem(key);
          return value;
        } catch (error) {
          console.error(error, 'an_analyzify', 'sessionStorage.get');
          return null;
        }
      },
      remove: function (key) {
        try {
          sessionStorage.removeItem(key);
        } catch (error) {
          console.error(`Error removing ${key} from sessionStorage:`, 'an_analyzify', 'sessionStorage.remove');
          console.error(error, 'an_analyzify', 'sessionStorage.remove');
        }
      }
    },

    // ============================================================================
    // CART UPSERT UTILITIES
    // ============================================================================

    getCartId: function () {
      try {
        const getFn = window?.analyzify?.cookieStorage && typeof window.analyzify.cookieStorage.get === "function" ? window.analyzify.cookieStorage.get : null;
        const rawCart = getFn ? getFn("cart") : (document?.cookie || "").split("; ").find(c => c.startsWith("cart="))?.split("=")[1];
        if (typeof rawCart === "string" && rawCart) {
          return rawCart.split("?")[0] || null;
        }
        return null;
      } catch (_e) {
        return null;
      }
    },

    hashString: function(str) {
      let hash = 5381;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
      }
      return (hash >>> 0).toString(36);
    },

    detectChangesByHash: function(attributes, options) {
      options = options || {};
      const namespace = options.namespace || 'cart';
      const skipKeys = options.skipKeys || [];
      const ignoreRemovedKeys = options.ignoreRemovedKeys || false;

      const storageKey = 'azfy_hashes_' + namespace;
      let prevHashes = {};

      try {
        const stored = window.analyzify.sessionStorage.get(storageKey);
        if (stored) {
          prevHashes = JSON.parse(stored);
        }
      } catch (e) {
        prevHashes = {};
      }

      const changedKeys = [];
      const newHashes = {};
      const hashFn = window.analyzify.hashString;
      const skipSet = new Set(skipKeys);

      for (const key in attributes) {
        if (skipSet.has(key)) continue;
        if (attributes[key] === undefined || attributes[key] === null) continue;

        const valueStr = typeof attributes[key] === 'string'
          ? attributes[key]
          : JSON.stringify(attributes[key]);
        const hash = hashFn(valueStr);
        newHashes[key] = hash;

        if (prevHashes[key] !== hash) {
          changedKeys.push(key);
        }
      }

      if (!ignoreRemovedKeys) {
        for (const key in prevHashes) {
          if (skipSet.has(key)) continue;
          if (!(key in newHashes)) {
            changedKeys.push(key);
          }
        }
      }

      const hasChanges = changedKeys.length > 0;

      if (hasChanges) {
        window.analyzify.sessionStorage.save(storageKey, JSON.stringify(newHashes));
        changedKeys.forEach(function(key) {
          window.analyzify.log(
            '[' + namespace + '] Key changed: ' + key,
            'an_analyzify',
            'detectChangesByHash'
          );
        });
      }

      return { hasChanges: hasChanges, changedKeys: changedKeys };
    },

    // Shopify data helpers for GTM
    getFirstVariant: function(product) {
      if (!product || !product.variants || product.variants.length === 0) return null;
      return product.variants[0];
    },

    // Get current variant function (used in variant change tracking)
    getCurrentVariant: function() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const variantParam = urlParams.get('variant');
        
        if (variantParam) {
          if (window.analyzify.getProductObj && window.analyzify.getProductObj.product) {
            const product = window.analyzify.getProductObj.product;
            const variant = product.variants.find(v => v.id.toString() === variantParam);
            if (variant) {
              return variant;
            }
          }
          
          // Fallback: return a basic variant object with the ID
          return { id: variantParam };
        }
        
        // If no variant in URL, try to get from form inputs
        const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
        for (const input of variantInputs) {
          if (input.value) {
            if (window.analyzify.getProductObj && window.analyzify.getProductObj.product) {
              const product = window.analyzify.getProductObj.product;
              const variant = product.variants.find(v => v.id.toString() === input.value);
              if (variant) {
                return variant;
              }
            }
            
            // Fallback: return a basic variant object with the ID
            return { id: input.value };
          }
        }
        
        if (window.analyzify.getProductObj && window.analyzify.getProductObj.product) {
          const product = window.analyzify.getProductObj.product;
          if (product.variants && product.variants.length > 0) {
            return product.variants[0];
          }
        }
        
        return null;
      } catch (error) {
        console.error('Error in getCurrentVariant:', error);
        return null;
      }
    },

    formatPrice: function(price, cents = false) {
      try {
        if (price == null) return 0;
        const match = price.toString().match(/-?\d+(\.\d+)?/);
        const numericPrice = match ? Number(match[0]) : NaN;
        if (isNaN(numericPrice)) return 0;
        return Number(parseFloat((numericPrice / (cents ? 100 : 1)).toFixed(2)));
      } catch (error) {
        console.error("Error formatting price:", error);
        return 0;
      }
    },

  getShopifyId: function (feed, itemId, variantId, sku) {
    try {
      // Validate inputs
      if (!feed || !itemId || !variantId) {
        if (sku) {
          return sku; // Return SKU if any parameter is missing
        } else {
          return null;
        }
      }

      // Construct and return the Shopify ID
      return `shopify_${feed}_${itemId}_${variantId}`;
    } catch (error) {
      console.error("Error in getShopifyId function:", error);
      return null; // Return null as a fallback in case of an error
    }
  },

    // Variant details helper (used in GTM)
    getVariantDetails: function(variants, variantId) {
      try {
        if(!variants || !variantId) return null;
        if (!Array.isArray(variants)) return null;
        const variantIdStr = variantId?.toString();
        const variant = variantIdStr ? variants.find((v) => v.id?.toString() === variantId?.toString()) : variants[0];
        return {
          id: variant?.id?.toString() || null,
          sku: variant?.sku?.toString() || null,
          title: variant?.title?.trim() || null,
          price: (variant?.price || 0) / 100,
          compare_at_price: (variant?.compare_at_price || 0) / 100,
          barcode: variant?.barcode?.toString() || null,
        };
      } catch (error) {
        console.error("Error in getVariantDetails function:", error);
        return {
          id: null, sku: null, title: null, price: 0, compare_at_price: 0, barcode: null
        };
      }
    },

    // Quantity finder (used for events except wishlist and page template)
    findQuantity: function () {
      try {
        const getQuantityValues = (attributes) => {
          const quantities = [];
          Object.entries(attributes).forEach(([key, values]) => {
            values.forEach((value) => {
              const selector = `[${key}="${value}"]`;
              const element = document.querySelector(selector);
              if (element && element.value) {
                quantities.push(element.value);
              }
            });
          });
          return quantities;
        };
        const quantities = getQuantityValues(analyzify.product_quantity || {});
        return Number(quantities.length > 0 ? quantities[0] : 1);
      } catch (error) {
        console.error("Error in findQuantity function:", error);
        return 1;
      }
    },

    getTypeFromTag: function (tagName) {
      const typeMap = { A: "link", BUTTON: "button", NAV: "layer" };
      return typeMap[tagName] || "text";
    },

 getClientId: async function (measurementId) {
    try {

      const gaCookie = window.analyzify.cookieStorage.get("_ga");

      if (gaCookie) {
        const match = gaCookie.match(/GA\d+\.\d+\.(\d+\.\d+)/);
        if (match) {
          const clientId = match[1];
          window.analyzify.saveToLocalStorage("clientId", clientId);
          
          analyzify.log(`Client ID from cookie: ${clientId}`, 'an_analyzify', 'getClientId');

          return clientId;
        }
      }
      return null;
    } catch (error) {
      analyzify.log(error, 'an_analyzify', 'getClientId');
      return null;
    }
  },

   getSessionId: async function(measurementId) {
    try {
      if (!measurementId) {
        measurementId = window.analyzify?.properties?.SERVERSIDE?.measurement_id;
      }
      if (!measurementId?.startsWith('G-')) {
        window.analyzify.log('No valid measurementId found - unable to retrieve session ID, or measurementId does not start with G-', null, 'an_analyzify', 'getSessionId');
        return null;
      }
      window.analyzify.log(`measurementId: ${measurementId}`, measurementId, 'an_analyzify', 'getSessionId');

      const cookieName = `_ga_${measurementId.substring(2)}`;
      const gaCookie = window.analyzify.cookieStorage.get(cookieName);
      window.analyzify.log('gaCookie', gaCookie, 'an_analyzify', 'getSessionId');

      if (gaCookie) {
        let match;
        if (gaCookie.startsWith('GS1')) {
          match = gaCookie.match(/GS1\.\d+\.(\d+)/);
        } else if (gaCookie.startsWith('GS2')) {
          match = gaCookie.match(/GS2\.\d+\.s(\d+)/);
        }
        const sessionId = match?.[1];

        if (sessionId && window.analyzify.getFromLocalStorage("sessionId") !== sessionId) {
          window.analyzify.saveToLocalStorage("sessionId", sessionId);
        }
        
        window.analyzify.log(`sessionId (gaCookie): ${sessionId}`, sessionId ? sessionId : null, 'an_analyzify', 'getSessionId');
        if (sessionId) return sessionId;
      }      
      return window.analyzify.getFromLocalStorage("sessionId") || null;

    } catch (error) {
      window.analyzify.log(error, 'an_analyzify', 'getSessionId');
      return null;
    }
  },

  // used as assistant for navDetails feature.
  findNavChildrenElemInPath: function (pathArray, attributeObj) {
    if (!pathArray) {
  
      return null;
    }
  
    let clickedLink = null;
    
    for (let i = 0; i < pathArray.length; i++) {
      if (pathArray[i].tagName === 'A' && pathArray[i].hasAttribute('href')) {
        const href = pathArray[i].getAttribute('href');
        
        const isValidHref = href && href.trim() !== '' && href.trim() !== '#';
        
        if (isValidHref) {
          clickedLink = pathArray[i];
          break;
        }
      }
    }
    
    if (!clickedLink) {
      analyzify.log('❌ No valid link element found, returning null');
      return null;
    }
    let hasMatchingParent = false;
    let matchedClass = null;
    
    for (let i = 0; i < pathArray.length; i++) {
      
      for (const attribute in attributeObj) {
        if (attributeObj.hasOwnProperty(attribute)) {
          const attributeName = attribute;
          const attributeValues = attributeObj[attribute];
          
          if (pathArray[i].hasAttribute && pathArray[i].hasAttribute(attributeName)) {
            const elementAttributeValue = pathArray[i].getAttribute(attributeName);
          
            
            for (let j = 0; j < attributeValues.length; j++) {
              const selectedValue = attributeValues[j];
              
              if (elementAttributeValue.indexOf(selectedValue) > -1) {
                hasMatchingParent = true;
                matchedClass = selectedValue === 'main-nav' ? 'mega_mobile' : 'mega';
                analyzify.log(`        📱 Matched class determined: "${matchedClass}"`);
                break;
              }
            }
          }
        }
        if (hasMatchingParent) {
          analyzify.log('    🚪 Breaking out of attribute loop - match found');
          break;
        }
      }
      if (hasMatchingParent) {
        analyzify.log('  🚪 Breaking out of element loop - match found');
        break;
      }
    }
    
    if (!hasMatchingParent) {
      analyzify.log('❌ No matching parent element found, returning null');
      return null;
    }
    
    const href = clickedLink.getAttribute('href');
  
  
    let navDetail = window.analyzify.navigationPaths && window.analyzify.navigationPaths[href];

    if (!navDetail && !window.analyzify.navigationPaths) {
      // Fallback: if navigationPaths isn't loaded yet, create a basic navDetail from the clicked element
      const linkText = clickedLink.textContent?.trim() || '';
      const linkHref = href || '';
      
      // Create a basic navigation detail using the element's text and matched class
      navDetail = `${linkText}`.replace(/\s+/g, '_').toLowerCase();
      analyzify.log(`Created fallback navDetail: "${navDetail}"`, 'an_analyzify', 'findNavChildrenElemInPath');
    }
  
    if (!navDetail) {
      const similarUrls = Object.keys(window.analyzify.navigationPaths || {}).filter(url => {
        return url.includes('vendors') || url.toLowerCase().includes('agolde');
      });
      
      // Check if there's a case sensitivity or encoding issue
      const allUrls = Object.keys(window.analyzify.navigationPaths || {});
      const matchingUrl = allUrls.find(url => url.toLowerCase() === href.toLowerCase());
      if (matchingUrl) {
        navDetail = window.analyzify.navigationPaths[matchingUrl];
      }
    }
    
    if (navDetail) {
      navDetail = `${matchedClass}:${navDetail}`;
      
      sessionStorage.setItem('azfy_navDetail', navDetail);
      analyzify.log(`Navigation detail recorded: ${navDetail}`, 'an_analyzify', 'findNavChildrenElemInPath');
    } else {
      analyzify.log('⚠️  No navigation detail found in mapping', 'an_analyzify', 'findNavChildrenElemInPath');
    }
    
    const result = {
      element: clickedLink,
      matchedClass: matchedClass,
      navDetail: navDetail
    };
    
    analyzify.log(`Clicked navigation link found: ${href}`, 'an_analyzify', 'findNavChildrenElemInPath');
    analyzify.log(`Clicked link text: "${clickedLink.textContent?.trim()}"`, 'an_analyzify', 'findNavChildrenElemInPath');
    
    return result;
  },
  

    // find element in path (used in matching the clicked elements with event triggers) 
    findElemInPath: function (pathArray, attributeObj) {

      let buttonFound = null;
      if (pathArray) {
        for (let i = 0; i < pathArray.length; i++) {
          for (const attribute in attributeObj) {
            if (attributeObj.hasOwnProperty(attribute)) {
              const attributeName = attribute;
              const attributeValues = attributeObj[attribute];
              if (
                pathArray[i].hasAttribute !== undefined &&
                pathArray[i].hasAttribute(attributeName) === true
              ) {
                attributeValues.forEach(function (selectedValue) {
                  if (
                    pathArray[i]
                      .getAttribute(attributeName)
                      .indexOf(selectedValue) > -1
                  ) {
                    analyzify.log(`'${selectedValue}' found in '${attributeName}' attribute list.`, 'an_analyzify', 'findElemInPath');


                    buttonFound = pathArray[i];
                    analyzify.foundElements.push(pathArray[i]);
                    analyzify.foundAtcElementForms.push(
                      pathArray[i].closest("form[action='/cart/add']"),
                    );
                    analyzify.foundBoostElements.push(
                      pathArray[i].closest(".boost-pfs-filter-product-item"),
                    );
                  }
                });
              }
            }
          }
        }
      }
      return buttonFound;
    },

    
    hashValue: async function (value) {
      try {
        if (!value) return null;

        if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
          console.error('Crypto API is not available in this browser. Unable to hash value.');
          return null;
        }

        const encoder = new TextEncoder();
        const data = encoder.encode(value);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
      } catch (error) {
        console.error('Error hashing value:', error);
        return null;
      }
    },
    
    getBreadcrumbCategories: function() {
      return new Promise((resolve) => {
        const extractBreadcrumbs = () => {
          try {
            const breadcrumbElement = document.querySelector('.' + window.analyzify.breadcrumb_attributes.class[0]);
            const generalCategories = {};
            const itemCategories = {};

            // If breadcrumb exists, parse it; otherwise still set template-based defaults below
            const links = breadcrumbElement ? breadcrumbElement.querySelectorAll('a') : [];
            
            links.forEach((link, index) => {
              const text = link.textContent.trim();
              if (text) {
                const formattedText = text.toLowerCase().replace(/\s+/g, '_');
                
                // General categories (cat_1, cat_2, etc.)
                const generalKey = index === 0 ? 'cat_1' : `cat_${index + 1}`;
                generalCategories[generalKey] = formattedText;
                
                // Item categories (item_category, item_category2, etc.)
                const itemKey = index === 0 ? 'item_category' : `item_category${index + 1}`;
                itemCategories[itemKey] = formattedText;
              }
            });
            
            // Add product name from product data
            const product = window.analyzify.getProductObj?.product;
            if (product?.title) {
              const catIndex = Object.keys(generalCategories).length + 1;
              const formattedTitle = product.title.trim().toLowerCase().replace(/\s+/g, '_');
              
              // Add to general categories
              const generalKey = catIndex === 1 ? 'cat_1' : `cat_${catIndex}`;
              generalCategories[generalKey] = formattedTitle;
              
              // Add to item categories
              const itemKey = catIndex === 1 ? 'item_category' : `item_category${catIndex}`;
              itemCategories[itemKey] = formattedTitle;
            }
            
            // Store both formats in global window.analyzify variables
            // Add template-based cat_1 for specific page types (these override any breadcrumb cat_1)
            const template = window.analyzify?.shopify_template;
            if (template === 'index') {
              generalCategories.cat_1 = 'home';
              itemCategories.item_category = 'home';
              window.analyzify.log('Set cat_1 to "home" for index template', 'an_analyzify', 'getBreadcrumbCategories');
            } else if (template === 'search') {
              generalCategories.cat_1 = 'search';
              itemCategories.item_category = 'search';
              window.analyzify.log('Set cat_1 to "search" for search template', 'an_analyzify', 'getBreadcrumbCategories');
            } else if (template === 'page') {
              generalCategories.cat_1 = window.analyzify.extractPageNameFromUrl();
              itemCategories.item_category = 'page';
              window.analyzify.log('Set cat_1 to "page" for page template', 'an_analyzify', 'getBreadcrumbCategories');
            }
            
            window.analyzify.log('Final breadcrumb categories: ' + JSON.stringify(generalCategories), 'an_analyzify', 'getBreadcrumbCategories');
            
            window.analyzify.breadcrumbCategories = generalCategories;
            window.analyzify.breadcrumbCategoriesItem = itemCategories;
            
            resolve(generalCategories);
          } catch (error) {
            console.error('Error extracting breadcrumbs:', error);
            // Set empty objects on error
            window.analyzify.breadcrumbCategories = {};
            window.analyzify.breadcrumbCategoriesItem = {};
            resolve({});
          }
        };
        
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', extractBreadcrumbs, { once: true });
        } else {
          extractBreadcrumbs();
        }
      });
    },
     
     // Item object helper function
     getItemObj: async function(itemObj) {
       if(!itemObj) return {};
       
       try {
         const item = itemObj?.variant || itemObj?.merchandise || itemObj?.productVariant;
         if(!item) return {};

         const discountAll = itemObj?.discountAllocations?.reduce((total, discount) => total + (parseFloat(discount?.amount?.amount) || 0), 0) || 0;
         const computedDiscount = itemObj?.finalLinePrice?.amount < item?.price?.amount ? item?.price?.amount - itemObj?.finalLinePrice?.amount : 0;
         const getDiscount = Math.abs((discountAll || computedDiscount).toFixed(2));

         const item_properties = itemObj?.properties || null;

         const itemData = {
           item_id: item?.product?.id || itemObj?.id || null,
           item_name: item?.product?.title || itemObj?.title || null,
           item_category: item?.product?.type || null,
           item_brand: item?.product?.vendor || null,
           item_sku: item?.product?.handle || null,
           discount: getDiscount || 0,
           item_variant: item?.title || null,
           item_variant_id: item?.id || null,
           price: item?.price?.amount || itemObj?.finalLinePrice?.amount || 0,
           quantity: item?.quantity || itemObj?.quantity || 1,
           currency: item?.price?.currencyCode || itemObj?.finalLinePrice?.currencyCode || window.analyzify?.currency || 'USD',
           properties: item_properties
         };

         return itemData;
       } catch (err) {
         console.error('Error in getItemObj:', err);
         return {};
       }
     },
     
     // Cart data helper functions
    getCart: {
      quantities: (cartData) => {
        if (!cartData || !cartData.items || !Array.isArray(cartData.items)) return '';
        return cartData.items.map(item => item.quantity || 1).join(',');
      },

      sizes: (cartData) => {
        if (!cartData || !cartData.items || !Array.isArray(cartData.items)) return '';
        return cartData.items.map(item => item.variant_title?.trim() || '').filter(size => size).join(',');
      },

      skus: (cartData) => {
        if (!cartData || !cartData.items || !Array.isArray(cartData.items)) return '';
        return cartData.items.map(item => item.sku || '').filter(sku => sku).join(',');
      },

      units: (cartData) => {
        if (!cartData || !cartData.items || !Array.isArray(cartData.items)) return '';
        return cartData.items.reduce((total, item) => total + (item.quantity || 1), 0).toString();
      }
    },

    // Event ID generator (used extensively for events)
    generateEventId: function(prefix = 'sh', separator = '-', salt = '') { 
      try {
        const generateHexSegment = (length) => {
          const randomValues = Array.from({ length }, () => Math.floor(Math.random() * 16).toString(16));
          const saltedValues = randomValues.map((val, index) => {
            const saltChar = salt.charCodeAt(index % salt.length) || 0;
            return ((parseInt(val, 16) + saltChar) % 16).toString(16);
          });
          return saltedValues.join('');
        };
        const segments = [8, 4, 4, 4, 12].map(generateHexSegment); 
        const uuid = segments.join(separator);
        return `${prefix}${separator}${uuid}`.toLowerCase();
      } catch (error) {
        console.error('Error generating event ID:', error);
        return null;
      }
    },

    // Event ID manager (used extensively for events)
    eventId: (function(salt) {
      const eventIds = {};
      const defaultEventType = 'default';
      return {
        get: function(eventType = defaultEventType) { 
          if (!eventIds[eventType]) {
            eventIds[eventType] = window.analyzify.generateEventId('sh', '', salt);
          }
          return eventIds[eventType];
        },
        reset: function(eventType = defaultEventType) { 
          eventIds[eventType] = window.analyzify.generateEventId('sh', '', salt);
          return eventIds[eventType];
        }
      };
    })('z9y8x7w6v5u4t3s2'),

    // Path segment checker (used extensively for events)
    isPathSegmentPresent: function (segment) {
      try {
        if (typeof segment !== "string" || segment.trim() === "") {
          throw new Error("Invalid segment: must be a non-empty string.");
        }
        const currentPath = window.location.pathname;
        return currentPath.includes(segment);
      } catch (error) {
        console.error(`Error in isPathSegmentPresent function:`, error);
        return false;
      }
    },

    // SSAP values (used extensively for events)
    SSAP_vals: function() {
      return {
        page_type: analyzify.shopify_template || 'other',
        page_currency: analyzify.currency || 'USD',
        page_id: Date.now(),
        cart_id: analyzify.cart_id || null
      };
    },

   
    getCartData: function() {
      return window.analyzify?.shopify_cart || {};
    },

    getProductData: function() {
      return window.analyzify?.shopify_product || {};
    },

    getCustomerData: function() {
      return window.analyzify?.shopify_customer || {};
    },

    getCurrentPageType: function() {
      return window.analyzify?.shopify_template || 'other';
    },

    getCurrentPageUrl: function() {
      return window.location.href;
    },

    sanitizeString: function(str) {
      if (!str) return null;
      return str.toString().trim();
    },

    // Enhanced e-commerce helpers
    buildEcommerceItem: function(product, index = 0) {
      const firstVariant = analyzify.getFirstVariant(product);
      const compareAtPrice = analyzify.formatPrice(product?.compare_at_price);
      const actualPrice = analyzify.formatPrice(firstVariant?.price ?? product?.price);
      const discount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;

      return {
        id: analyzify.getShopifyId(
          analyzify.feed_region,
          product?.id,
          firstVariant?.id,
          firstVariant?.sku
        ),
        item_id: product?.id?.toString() || null,
        item_name: analyzify.sanitizeString(product?.title),
        item_category: product?.product_type || product?.type || null,
        item_brand: analyzify.sanitizeString(product?.vendor),
        item_variant: analyzify.sanitizeString(firstVariant?.title),
        item_variant_id: firstVariant?.id?.toString() || null,
        item_sku: product?.handle || null,
        price: actualPrice,
        discount: analyzify.formatPrice(discount),
        quantity: 1,
        index: index
      };
    },

    cookieStorage: {
      get: function (cookieName) {
        try {
          const name = cookieName + "=";
          const decodedCookie = decodeURIComponent(document.cookie);
          const cookies = decodedCookie.split(";");
          for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name)) {
              return cookie.substring(name.length);
            }
          }
          return null;
        } catch (error) {
          if (window.analyzify && window.analyzify.log) {
            window.analyzify.log(error, 'an_analyzify', 'cookieStorage.get');
          } else {
            console.error('Error getting cookie:', error);
          }
          return null;
        }
      },
      save: function (key, value, maxAge = 2592000) {
        try {
          if (value) {
            const cookieValue = typeof value === "object" ? JSON.stringify(value) : value;
            document.cookie = `${key}=${cookieValue}; path=/; max-age=${maxAge}`; // Default: 30 days
          }
        } catch (error) {
          if (window.analyzify && window.analyzify.log) {
            window.analyzify.log(error, 'an_analyzify', 'cookieStorage.save');
          } else {
            console.error('Error saving cookie:', error);
          }
        }
      },
      delete: function (key) {
        try {
          document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        } catch (error) {
          if (window.analyzify && window.analyzify.log) {
            window.analyzify.log(error, 'an_analyzify', 'cookieStorage.delete');
          } else {
            console.error('Error deleting cookie:', error);
          }
        }
      }
    },

    // --- Additional helpers required for GTM click event handling ---
    getVariantInput: function(formElement) {
      try {
        let variantInput = window.analyzify.getCurrentVariant?.()?.id;
        if (formElement) {
          const formVariantInput = Array.from(formElement.elements).find(item => item.name === 'id');
          variantInput = formVariantInput ? formVariantInput.value : variantInput;
        }
        return variantInput;
      } catch (error) {
        return analyzify.log('Error getting variant input', error);
      }
    },

    findClickedProduct: function(element, colProds) {
      try {
        if (!element || !colProds) return null;
        let clickedProduct = null;
        
        const variantId = element.getAttribute('data-variant-id');
        if (variantId) {
          clickedProduct = colProds.find(product => 
            product.variants.some(variant => variant.id.toString() === variantId.toString())
          );
        }
        
        if (!clickedProduct) {
          const productId = element.getAttribute('data-product-id') || element.getAttribute('data-id');
          if (productId) {
            clickedProduct = colProds.find(product => product.id.toString() === productId.toString());
          }
        }
        
        if (!clickedProduct && element.getAttribute('href')) {
          const handleMatch = element.getAttribute('href').match(/\/products\/([a-zA-Z0-9\-_]+)/);
          if (handleMatch && handleMatch[1]) {
            clickedProduct = colProds.find(product => product.handle === handleMatch[1]);
          }
        }
        
        return clickedProduct;
      } catch (error) {
        console.error('Error processing findClickedProduct:', error);
        return null;
      }
    },

    // needed for add to cart events
    findAddedProduct: function(element, colProds) {
      try {
        if (!element || !colProds) return null;
        let addedProduct = null;
        
        // First try data attributes
        const variantId = element.getAttribute('data-variant-id');
        if (variantId) {
          addedProduct = colProds.find(product => 
            product.variants.some(variant => variant.id.toString() === variantId.toString())
          );
          if (addedProduct) {
            window.analyzify.addedProduct = addedProduct;
            return addedProduct;
          }
        }
        
        const productId = element.getAttribute('data-product-id') || element.getAttribute('data-id');
        if (productId) {
          addedProduct = colProds.find(product => product.id.toString() === productId.toString());
          if (addedProduct) {
            window.analyzify.addedProduct = addedProduct;
            return addedProduct;
          }
        }
        
        // Fallback to form extraction
        const extractIdFromForm = (element) => {
          const form = element.closest('form');
          if (form) {
            const inputs = form.querySelectorAll('input');
            for (const input of inputs) {
              if (input.name === 'id' || input.getAttribute('id') === 'id' || input.getAttribute('data-id') === 'id') {
                return input.value;
              }
            }
          }
          return null;
        };
        
        const potentialIds = [
          extractIdFromForm(element),
        ].filter(Boolean);
        
        if (potentialIds.length) {
          addedProduct = colProds.find(product =>
            potentialIds.includes(product.id.toString()) ||
            product.variants.some(variant => potentialIds.includes(variant.id.toString()))
          );
          if (addedProduct) {
            window.analyzify.addedProduct = addedProduct;
            return addedProduct;
          }
        }
        
        return null;
      } catch (error) {
        console.error('Error processing findAddedProduct:', error);
        return null;
      }
    }
  };

  if (window.analyzify) {
    window.analyzify.cart_id = window.analyzify.cookieStorage.get('cart')?.split('?')[0] || null;
  }

  //used for collecting browser data to send to update.js. Needed for utm journey tracking of the client and for serverside tracking.
  //tightly knit and tested for hundreds of stores. configuration is not recommended.
  window.collectCartData = async function (measurementId) {
    try {
      const paramConfig = { 
        azfy_clids: {
          type: "clids",
          params: {
            gclid: { type: "query", method: "gclid", default: null, prefix: "g" },
            fbclid: { type: "query", method: "fbclid", default: null, prefix: "fb" },
            ttclid: { type: "query", method: "ttclid", default: null, prefix: "tt" },
          },
        },
        azfy_cookies: {
          type: "cookies",
          params: {
            fbp: { type: "cookie", method: "_fbp", default: null, prefix: "fbp" },
            fbc: { type: "cookie", method: "_fbc", default: null, prefix: "fbc" },
            ttp: { type: "cookie", method: "_ttp", default: null, prefix: "tt" },
            ...(measurementId ? {
              ga: { type: "async", method: "getClientId", args: [measurementId], default: null, prefix: "ga" },
              [`ga_${measurementId.substring(2)}`]: { type: "async", method: "getSessionId", args: [measurementId], default: null, prefix: `ga_${measurementId.substring(2)}` }
            } : {})
          }
        },
        azfy_utm_history: {
          type: "utm_history",
          params: {
            utm_source: {
              type: "query",
              method: "utm_source",
              default: null,
              prefix: "src",
            },
            utm_medium: {
              type: "query",
              method: "utm_medium",
              default: null,
              prefix: "med",
            },
            utm_campaign: {
              type: "query",
              method: "utm_campaign",
              default: null,
              prefix: "camp",
            },
            utm_content: {
              type: "query",
              method: "utm_content",
              default: null,
              prefix: "cont",
            },
            utm_term: { type: "query", method: "utm_term", default: null, prefix: "term" },
            utm_id: { type: "query", method: "utm_id", default: null, prefix: "id" },
            azfy_pid: { type: "query", method: "pida", default: null, prefix: "pid" },
            azfy_referrer: {
              type: "direct",
              method: () => {
                const ref = document.referrer;
                if (ref === "") return "direct";
                const currentDomain = window.location.hostname;
                const referrerDomain = new URL(ref).hostname;
                return currentDomain === referrerDomain ? null : ref;
              },
              default: null,
              prefix: "ref",
            },
          },
        },
        azfy_consent: {
          type: "direct",
          method: () =>
            !window.analyzify.consent_active ||
            (window.analyzify.current_consent?.ad_storage === "granted" &&
              window.analyzify.current_consent?.analytics_storage ===
                "granted"),
          default: null,
        },
      };

      window.analyzify.cart_attributes = {};
      window.analyzify.extractedCartDataObj = {}

      async function formatClidsAndCookies(config) {
        const values = {};
        for (const [key, paramConfig] of Object.entries(config.params)) {
          if (paramConfig.type === "query") {
            const value =
              window.analyzify.getQueryParam(paramConfig.method) ||
              paramConfig.default;

            if (value) {
              values[key] = paramConfig.prefix ? `${paramConfig.prefix}:${value}` : value;
            } else {
              values[key] = null;
            }
          } else if (paramConfig.type === "cookie" || paramConfig.type === "async") {
            let value;
            if (paramConfig.type === "cookie") {
              value = window.analyzify.cookieStorage.get(paramConfig.method) || paramConfig.default;
            } else {
              value = await window.analyzify[paramConfig.method](...paramConfig.args) || paramConfig.default;
            }
            if (value) {
              values[key] = paramConfig.prefix ? `${paramConfig.prefix}:${value}` : value;
            } else {
              values[key] = null;
            }
          }
        }

        const valuesArray = Object.values(values);
        if (valuesArray.every((value) => value === null)) {
          return undefined;
        }
        return valuesArray;
      }

      function formatUtmHistory(config) {
        const currentCartId = window.analyzify.cart_id;
        const lastKnownCartId = window.analyzify.getFromLocalStorage("azfy_cart_id");
        const cartIdChanged = currentCartId !== lastKnownCartId;
        
        const restoreSessionFromCookies = () => {
          const sessionHistoryStr = window.analyzify.sessionStorage.get("azfy_utm_history");
          const cookieHistoryStr = window.analyzify.cookieStorage.get("azfy_utm_history");
          const currentCartId = window.analyzify.cart_id;
                      
          if ((!sessionHistoryStr || sessionHistoryStr === "{}") && cookieHistoryStr && currentCartId) {
            try {
              const cookieHistory = JSON.parse(cookieHistoryStr);
              const matchingEntries = {};
              
              Object.keys(cookieHistory).forEach(timestamp => {
                const entry = cookieHistory[timestamp];
                const entryCartId = entry.cartId || (Array.isArray(entry) ? currentCartId : null);
                
                if (entryCartId === currentCartId) {
                  matchingEntries[timestamp] = entry;
                }
              });
              
              if (Object.keys(matchingEntries).length > 0) {
                window.analyzify.sessionStorage.save("azfy_utm_history", JSON.stringify(matchingEntries));
              }
            } catch (e) {
              window.analyzify.log("error restoring session from cookies:", e);
            }
          }
        };
        
        restoreSessionFromCookies();

        const formatRefValue = (refUrl) => {
          if (!refUrl || refUrl === "direct") return refUrl;
          
          try {
            const url = new URL(refUrl);
            let hostname = url.hostname;
            
            // Remove www. prefix if present
            if (hostname.startsWith('www.')) {
              hostname = hostname.substring(4);
            }
            
            return hostname;
          } catch (e) {
            return refUrl;
          }
        };

        const isPlaceholderValue = (value) => {
          if (!value || typeof value !== 'string') return false;
          
          const placeholderPatterns = [
            '{source}', '{medium}', '{campaign}', 
            '{content}', '{term}', '{id}'
          ];
          
          return placeholderPatterns.includes(value.toLowerCase());
        };

        const currentValues = {};

        const utmValues = {
          utm_source: config.params.utm_source.default,
          utm_medium: config.params.utm_medium.default,
          utm_campaign: config.params.utm_campaign.default,
          utm_content: config.params.utm_content.default,
          utm_term: config.params.utm_term.default,
          utm_id: config.params.utm_id.default,
          azfy_pid: config.params.azfy_pid.default,
          azfy_referrer: config.params.azfy_referrer.default,
        };

        for (const [utmKey, utmConfig] of Object.entries(config.params)) {
          if (utmConfig.type === "direct") {
            currentValues[utmKey] = utmConfig.method();
          } else if (utmConfig.type === "query") {
            const queryValue = window.analyzify.getQueryParam(utmConfig.method);
            currentValues[utmKey] = queryValue || utmConfig.default;
          }
          if (currentValues[utmKey] !== null) {
            if (isPlaceholderValue(currentValues[utmKey])) {
              utmValues[utmKey] = null;
            } else {
              if (utmKey === 'azfy_referrer') {
                utmValues[utmKey] = formatRefValue(currentValues[utmKey]);
              } else {
                utmValues[utmKey] = currentValues[utmKey];
              }
            }
          }
        }
        
        const formattedUtmValues = [];
        for (const [key, value] of Object.entries(utmValues)) {
          if (value !== null && value !== undefined) {
            const paramConfig = config.params[key];
            if (paramConfig && paramConfig.prefix) {
              formattedUtmValues.push(`${paramConfig.prefix}:${value}`);
            } 
          }
        }
        
        if (formattedUtmValues.length === 0) {
          return undefined;
        }

        const existingSessionHistoryStr = window.analyzify.sessionStorage.get("azfy_utm_history");
        const existingCookieHistoryStr = window.analyzify.cookieStorage.get("azfy_utm_history");
        const existingLocalHistoryStr = window.analyzify.getFromLocalStorage("azfy_utm_history");
        
        let existingSessionHistory = {};
        let existingCookieHistory = {};
        let existingLocalHistory = {};

        if (existingSessionHistoryStr && existingSessionHistoryStr !== "{}") {
          try {
            existingSessionHistory = JSON.parse(existingSessionHistoryStr);
          } catch (e) {
        
            window.analyzify.log(
              "Error parsing utm_history",
              e,
              "an_analyzify",
              "handleUtmHistory"
            );
            existingSessionHistory = {};
          }
        }

        if (existingCookieHistoryStr && existingCookieHistoryStr !== "{}") {
          try {
            existingCookieHistory = JSON.parse(existingCookieHistoryStr);
          } catch (e) {
            window.analyzify.log("Error parsing cookie utm_history: " + e, 'an_analyzify', 'utm_history');
            existingCookieHistory = {};
          }
        }

        if (existingLocalHistoryStr && existingLocalHistoryStr !== "{}") {
          try {
            existingLocalHistory = JSON.parse(existingLocalHistoryStr);
          } catch (e) {
            window.analyzify.log("Error parsing local utm_history: " + e, 'an_analyzify', 'utm_history');
            existingLocalHistory = {};
          }
        }
        
        if (cartIdChanged) {
          if (currentCartId) {
            window.analyzify.saveToLocalStorage("azfy_cart_id", currentCartId);
          }
        }

        const addCartIdToHistory = (history) => {
          const updated = {};
          Object.keys(history).forEach(timestamp => {
            const entry = history[timestamp];
            if (Array.isArray(entry)) {
              updated[timestamp] = {
                values: entry,
                cartId: window.analyzify.cart_id
              };
            } else if (entry && typeof entry === 'object' && entry.values) {
              updated[timestamp] = {
                values: entry.values,
                cartId: entry.cartId || window.analyzify.cart_id
              };
            } 
          });
          return updated;
        };

        let existingHistory = {
          ...existingLocalHistory,
          ...existingCookieHistory,
          ...existingSessionHistory
        };
        
        const timestamps = Object.keys(existingHistory).sort((a, b) => parseInt(b) - parseInt(a));
        const lastTimestamp = timestamps[0];
        
        let needsCartIdUpdate = false;
        if (lastTimestamp) {
          const lastEntry = existingHistory[lastTimestamp];
          needsCartIdUpdate = Array.isArray(lastEntry) || !lastEntry.cartId || lastEntry.cartId === null;
        }
        
        let isDuplicate = false;
        if (lastTimestamp) {
          const lastEntry = existingHistory[lastTimestamp];
          const entryValues = Array.isArray(lastEntry) ? lastEntry : lastEntry.values;
          
          if (Array.isArray(entryValues) && Array.isArray(formattedUtmValues)) {
            isDuplicate = entryValues.length === formattedUtmValues.length &&
              entryValues.every((value, index) => value === formattedUtmValues[index]);
          } else if (entryValues && typeof entryValues === 'object' && !Array.isArray(entryValues)) {
            isDuplicate = false;
          }
        } 
        
        const isSessionStorageEmpty = Object.keys(existingSessionHistory).length === 0;
        
        const isSameDomain = document.referrer
          ? new URL(document.referrer).hostname === window.location.hostname
          : false;

        if ((!isDuplicate && !isSameDomain) || isSessionStorageEmpty) {
          const timestamp = Math.floor(Date.now() / 1000).toString();
          const cartId = window.analyzify.cart_id;
          
          existingSessionHistory = addCartIdToHistory(existingSessionHistory);
          existingCookieHistory = addCartIdToHistory(existingCookieHistory);
          existingLocalHistory = addCartIdToHistory(existingLocalHistory);
          
          const utmEntryWithCartId = {
            values: formattedUtmValues,
            cartId: cartId
          };
          
          existingHistory[timestamp] = utmEntryWithCartId;
          existingSessionHistory[timestamp] = utmEntryWithCartId;
          existingCookieHistory[timestamp] = utmEntryWithCartId;
          existingLocalHistory[timestamp] = utmEntryWithCartId;
          
          window.analyzify.sessionStorage.save("azfy_utm_history", JSON.stringify(existingSessionHistory));
          window.analyzify.cookieStorage.save("azfy_utm_history", JSON.stringify(existingCookieHistory));
          window.analyzify.saveToLocalStorage(
            "azfy_utm_history",
            JSON.stringify(existingLocalHistory)
          );
        }  else if (needsCartIdUpdate) {
          existingSessionHistory = addCartIdToHistory(existingSessionHistory);
          existingCookieHistory = addCartIdToHistory(existingCookieHistory);
          existingLocalHistory = addCartIdToHistory(existingLocalHistory);
                      
          window.analyzify.sessionStorage.save("azfy_utm_history", JSON.stringify(existingSessionHistory));
          window.analyzify.cookieStorage.save("azfy_utm_history", JSON.stringify(existingCookieHistory));
          window.analyzify.saveToLocalStorage("azfy_utm_history", JSON.stringify(existingLocalHistory));
        } 

        const sessionHistoryForCartAttributes = {};
        Object.keys(existingSessionHistory).forEach(timestamp => {
          const entry = existingSessionHistory[timestamp];
          sessionHistoryForCartAttributes[timestamp] = entry.values || entry;
        });

        const formattedUTMHistory = Object.keys(sessionHistoryForCartAttributes).length === 0
          ? null
          : sessionHistoryForCartAttributes;
          
        return formattedUTMHistory;
      }
      
      async function getValue(key, config) {
        try {
          let value;
          switch (config.type) {
            case "utm_history":
              value = formatUtmHistory(config) || config.default;
              break;
            case "clids":
            case "cookies":
              value = await formatClidsAndCookies(config);
              break;
            case "cookie":
              value =
                window.analyzify.cookieStorage.get(config.method) ||
                config.default;
              break;
            case "query":
              value =
                window.analyzify.getQueryParam(config.method) ||
                config.default;
              break;
            case "async":
              value =
                (await window[config.method](...config.args)) ||
                config.default;
              break;
            case "direct":
              value = config.method();
              break;
            default:
              value = config.default;
          }

          return value;
        } catch (error) {
          window.analyzify.log(
            `Error getting ${key}: ${error}`,
            "an_analyzify",
            "collectCartData"
          );
          return null;
        }
      }

      async function processParam(key, config) {
        let value = await getValue(key, config);
      
        if (value === null || value === undefined) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          value = await getValue(key, config);
        }
      
        if (value !== null && value !== undefined) {
          window.analyzify.cart_attributes[key] = value;
          if (key !== "azfy_utm_history") {
            if (key === "azfy_clids" || key === "azfy_cookies" || key === "azfy_consent") {
              window.analyzify.sessionStorage.save(key, value);
            } else {
              window.analyzify.sessionStorage.save(key, value);
              window.analyzify.cookieStorage.save(key, value);
              window.analyzify.saveToLocalStorage(key, value);
            }
          }
        } else {
          let storedValue;
          
          if (key === "azfy_clids" || key === "azfy_cookies" || key === "azfy_consent") {
            storedValue = window.analyzify.sessionStorage.get(key);
          } else {
            storedValue = window.analyzify.sessionStorage.get(key);
      
            if (!storedValue) {
              storedValue = window.analyzify.cookieStorage.get(key);
            }
            if (!storedValue) {
              storedValue = window.analyzify.getFromLocalStorage(key);
            }
          }
          
          if (storedValue) {
            if ((key === "azfy_clids" && typeof storedValue === 'string' && storedValue.startsWith('[')) ||
                (key === "azfy_utm_history" && typeof storedValue === 'string' && storedValue.startsWith('{'))) {
              try {
                const parsed = JSON.parse(storedValue);
      
                if (key === "azfy_utm_history") {
                  const valuesOnly = {};
                  Object.keys(parsed).forEach(timestamp => {
                    const entry = parsed[timestamp];
                    valuesOnly[timestamp] = entry.values || entry;
                  });
                  window.analyzify.cart_attributes[key] = valuesOnly;
                } else {
                  window.analyzify.cart_attributes[key] = parsed;
                }
              } catch (e) {
                window.analyzify.cart_attributes[key] = storedValue;
              }
            } else {
              window.analyzify.cart_attributes[key] = storedValue;
            }
          }
        }
      }

      const promises = Object.keys(paramConfig).map(async (key) => {
        await processParam(key, paramConfig[key]);
      });
      await Promise.all(promises);

      for (const key in paramConfig) {
        if (
          paramConfig.hasOwnProperty(key) &&
          !window.analyzify.cart_attributes.hasOwnProperty(key)
        ) {
          window.analyzify.cart_attributes[key] = null;
        }
      }

      window.analyzify.log(
        "Final cart_attributes",
        "an_analyzify",
        "collectCartData"
      );
      window.analyzify.log(
        window.analyzify.cart_attributes,
        "an_analyzify",
        "collectCartData"
      );

      const extractCartData = async (cartAttributes) => {
        const cookies = cartAttributes?.azfy_cookies || [];
        const clids = cartAttributes?.azfy_clids || [];

        const findValue = (arr, prefix) => {
          if (!Array.isArray(arr) || !arr.length) return undefined;
          const item = arr.find(c => typeof c === 'string' && c.startsWith(`${prefix}:`));
          return item ? item.split(':')[1] : undefined;
        };

        return {
          fbp: findValue(cookies, 'fbp'),
          fbc: findValue(cookies, 'fbc'),
          ttp: findValue(cookies, 'tt'),
          ga: findValue(cookies, 'ga'),
          gclid: findValue(clids, 'g'),
          ttclid: findValue(clids, 'tt'),
          fbclid: findValue(clids, 'fb')
        };
      };

      window.analyzify.unformattedCartDataObj = await extractCartData(window.analyzify.cart_attributes);
      window.analyzify.unformattedCartDataObj.sessionId = window.analyzify.getFromLocalStorage("sessionId") || null;
      
      return window.analyzify.cart_attributes;
    } catch (error) {
      window.analyzify.log(
        "Error in collectCartData:",
        "an_analyzify",
        "collectCartData"
      );

      window.analyzify.log(error, "an_analyzify", "collectCartData");
      const fallbackObject = {};
      for (const key in paramConfig) {
        if (paramConfig.hasOwnProperty(key)) {
          fallbackObject[key] = null;
        }
      }
      return fallbackObject;
    }
  };

  // Store original updateCartAttributes function to queue it too
  const originalUpdateCartAttributes = async function (attributes) {
    // Kill switch: skip update.js requests when disabled (cart_upsert can still work independently)
    if (window.analyzify.properties?.SERVERSIDE?.update_js === false) {
      window.analyzify.log('update.js requests disabled (SERVERSIDE.update_js is false)', 'an_analyzify', 'analyzify_updateCartAttributes');
      return;
    }

    // Capture consent state at request time for accurate failure reporting
    const requestTimeConsent = window.analyzify?.current_consent || {};
    // Hoisted request context for consistent reporting in final catch-all
    let requestUrlPath = '/cart/update.js?app=azfy';
    let method = 'POST';
    let bodyString = '';
    let bodySizeBytes = null;
    let timeoutMs = null;

    try {
      window.analyzify.log(JSON.stringify(attributes, null, 2), 'an_analyzify', 'analyzify_updateCartAttributes');

      requestUrlPath = '/cart/update.js?app=azfy';
      method = 'POST';
      bodyString = JSON.stringify({ attributes });
      bodySizeBytes = bodyString ? bodyString.length : 0;

      const canUseBeacon = (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function');
      const tryBeacon = () => {
        if (!canUseBeacon) return false;
        try {
          const blob = new Blob([bodyString], { type: 'application/json' });
          return navigator.sendBeacon(requestUrlPath, blob);
        } catch (_) { return false; }
      };

      // If page becomes hidden while a request is pending, attempt to queue via sendBeacon
      let removeVisibilityHook = null;
      try {
        if (canUseBeacon && typeof document !== 'undefined') {
          const onHidden = () => {
            try {
              if (document.visibilityState === 'hidden') {
                try { window.analyzify.log('sendBeacon due to visibilitychange/pagehide', 'an_analyzify', 'analyzify_updateCartAttributes'); } catch (_) {}
                tryBeacon();
              }
            } catch (_) {}
            try {
              document.removeEventListener('visibilitychange', onHidden, true);
              window.removeEventListener('pagehide', onHidden, true);
            } catch (_) {}
          };
          document.addEventListener('visibilitychange', onHidden, { once: true, capture: true });
          window.addEventListener('pagehide', onHidden, { once: true, capture: true });
          removeVisibilityHook = () => {
            try {
              document.removeEventListener('visibilitychange', onHidden, true);
              window.removeEventListener('pagehide', onHidden, true);
            } catch (_) {}
          };
        }
      } catch (_) {}

      const timeoutMsCfg = Number(window.analyzify?.properties?.SERVERSIDE?.cartUpdateTimeoutMs);
      timeoutMs = Number.isFinite(timeoutMsCfg) && timeoutMsCfg > 0 ? timeoutMsCfg : null;
      const maxRetriesCfg = Number(window.analyzify?.properties?.SERVERSIDE?.cartUpdateRetries);
      const maxRetries = Number.isFinite(maxRetriesCfg) && maxRetriesCfg >= 0 ? maxRetriesCfg : 2;
      const baseBackoffCfg = Number(window.analyzify?.properties?.SERVERSIDE?.cartUpdateRetryBackoffMs);
      const baseBackoffMs = Number.isFinite(baseBackoffCfg) && baseBackoffCfg > 0 ? baseBackoffCfg : 400;

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      for (let attempt = 1; attempt <= (maxRetries + 1); attempt++) {
        const hasAbortController = (typeof AbortController !== 'undefined');
        const abortController = hasAbortController ? new AbortController() : null;
        let timeoutId = null;
        let didTimeout = false;
        if (abortController && timeoutMs) {
          timeoutId = setTimeout(() => {
            didTimeout = true;
            try { abortController.abort(); } catch (_) {}
          }, timeoutMs);
        }

        try {
          const start = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
          const response = await fetch(requestUrlPath, {
            method,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            keepalive: true,
            body: bodyString,
            signal: abortController ? abortController.signal : undefined
          });

          // Push update.js request to GTM dataLayer
          try {
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'update_request',
                cart_update_url: requestUrlPath,
                cart_update_method: method,
                cart_update_attempt: attempt,
                cart_update_body_size: bodySizeBytes,
                cart_id: window.analyzify.cart_id,
                user_agent: navigator.userAgent,
                cart_attributes: attributes
              });
            }
          } catch (gtmError) {
            window.analyzify.log('GTM update_request push failed: ' + gtmError, 'an_analyzify', 'analyzify_updateCartAttributes');
          }

          const end = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
          const durationMs = Math.round(end - start);
          if (timeoutId) { try { clearTimeout(timeoutId); } catch (_) {} }

          window.analyzify.log(`Shopify API Response: ${response.status}`, 'an_analyzify', 'analyzify_updateCartAttributes');

          if (response.ok) {
            window.analyzify.log('Cart attributes updated successfully', 'an_analyzify', 'analyzify_updateCartAttributes');
            if (removeVisibilityHook) { try { removeVisibilityHook(); } catch (_) {} }
            return;
          }

          // HTTP failure: report and decide on retry
          if (typeof window.analyzify.ssCartUpdateFailureEvent === 'function') {
            const category = response.status >= 500 ? 'http_5xx' : (response.status >= 400 ? 'http_4xx' : 'http');
            let details = '';
            const statusText = (typeof response.statusText === 'string' && response.statusText) ? response.statusText : '';
            const httpMessage = statusText ? `HTTP ${response.status} ${statusText}` : `HTTP ${response.status}`;
            try {
              const ct = response.headers ? (response.headers.get && response.headers.get('content-type')) || '' : '';
              if (ct && typeof ct === 'string' && ct.indexOf('application/json') !== -1) {
                const data = await response.clone().json();
                const reason = (data && (data.message || data.error || data.errors)) ? (data.message || data.error || data.errors) : '';
                details = typeof reason === 'string' ? reason : JSON.stringify(reason);
              } else {
                const text = await response.clone().text();
                details = text || '';
              }
            } catch (_) {}
            details = details ? String(details).replace(/\s+/g, ' ').slice(0, 140) : '';
            const headers_cf_ray = response && response.headers && response.headers.get ? response.headers.get('cf-ray') : null;
            const headers_server = response && response.headers && response.headers.get ? response.headers.get('server') : null;
            const headers_via = response && response.headers && response.headers.get ? response.headers.get('via') : null;
            const headers_cf_cache_status = response && response.headers && response.headers.get ? response.headers.get('cf-cache-status') : null;
            const headers_content_type = response && response.headers && response.headers.get ? response.headers.get('content-type') : null;
            const response_url = (typeof response.url === 'string' && response.url) ? response.url : null;
            const response_type = (typeof response.type === 'string' && response.type) ? response.type : null;
            const response_redirected = (typeof response.redirected === 'boolean') ? response.redirected : null;
            window.analyzify.ssCartUpdateFailureEvent({
              request_url_path: requestUrlPath,
              method,
              body_size_bytes: bodySizeBytes,
              attempt_number: attempt,
              timeout_ms: timeoutMs || null,
              status_code: response.status,
              error_category: category,
              error_message_sanitized: details ? `${httpMessage}: ${details}` : httpMessage,
              duration_ms: durationMs,
              http_message: httpMessage,
              status_text: statusText || '',
              response_url,
              response_type,
              response_redirected,
              response_headers_cf_ray: headers_cf_ray,
              response_headers_server: headers_server,
              response_headers_via: headers_via,
              response_headers_cf_cache_status: headers_cf_cache_status,
              response_headers_content_type: headers_content_type,
              response_body_excerpt: details,
              original_consent: requestTimeConsent,
              transport: 'fetch',
            session_id: (window.analyzify.getFromLocalStorage && window.analyzify.getFromLocalStorage('sessionId')) || null,
            reason_code: 'http_error',
            error_name: null,
            did_timeout: false,
            beacon_attempted: false
            });
          }

          const isRetryable = (response.status === 408 || response.status === 429 || (response.status >= 500 && response.status <= 504));
          if (attempt <= maxRetries && isRetryable) {
            await sleep(baseBackoffMs * attempt);
            continue;
          }
          if (removeVisibilityHook) { try { removeVisibilityHook(); } catch (_) {} }
          return;
        } catch (err) {
          if (timeoutId) { try { clearTimeout(timeoutId); } catch (_) {} }
          // Attempt to queue data via sendBeacon for abort/load failed cases
          try {
            const name = err && err.name ? String(err.name) : '';
            const msg = err && err.message ? String(err.message) : '';
            const isAbortLike = name === 'AbortError' || /abort|cancel/i.test(msg);
            const isLoadFailed = /load failed|failed to fetch/i.test(msg);
            var beaconAttempted = false;
            if (canUseBeacon && (isAbortLike || isLoadFailed)) {
              beaconAttempted = true;
              const queued = tryBeacon();
              if (queued) { if (removeVisibilityHook) { try { removeVisibilityHook(); } catch (_) {} } return; }
            }
          } catch (_) {}

          if (typeof window.analyzify.ssCartUpdateFailureEvent === 'function') {
            const isOffline = (typeof navigator !== 'undefined' && navigator.onLine === false);
            const durationMs = 0; // unknown when failed before timing; leaving 0
            let errorMessage = 'Network error: fetch failed';
            if (isOffline) errorMessage = 'Network error: browser is offline';
            if (err && err.message) errorMessage = String(err.message);
            const name = err && err.name ? String(err.name) : null;
            const msg = err && err.message ? String(err.message) : '';
            const isAbortLike = name === 'AbortError' || /abort|cancel/i.test(msg);
            const isLoadFailed = /load failed|failed to fetch/i.test(msg);
            const wasHidden = (function(){ try { return document.visibilityState === 'hidden'; } catch(_) { return false; } })();
            const reason = isOffline ? 'offline' : (didTimeout ? 'timeout' : (isAbortLike ? 'abort' : (isLoadFailed ? 'load_failed' : (wasHidden ? 'visibility_hidden' : 'unknown'))));
            window.analyzify.ssCartUpdateFailureEvent({
              request_url_path: requestUrlPath,
              method,
              body_size_bytes: bodySizeBytes,
              attempt_number: attempt,
              timeout_ms: timeoutMs || null,
              status_code: 0,
              error_category: 'network',
              error_message_sanitized: errorMessage,
              duration_ms: durationMs,
              http_message: 'NETWORK 0',
              status_text: '',
              response_url: null,
              response_type: null,
              response_redirected: null,
              response_headers_cf_ray: null,
              response_headers_server: null,
              response_headers_via: null,
              response_headers_cf_cache_status: null,
              response_headers_content_type: null,
              response_body_excerpt: '',
              original_consent: requestTimeConsent,
              transport: (canUseBeacon && wasHidden) ? 'beacon_fallback_attempted' : 'fetch',
              session_id: (window.analyzify.getFromLocalStorage && window.analyzify.getFromLocalStorage('sessionId')) || null,
              reason_code: reason,
              error_name: name,
              did_timeout: !!didTimeout,
              beacon_attempted: !!(typeof beaconAttempted !== 'undefined' && beaconAttempted)
            });
          }

          if (attempt <= maxRetries) {
            await sleep(baseBackoffMs * attempt);
            continue;
          }
          if (removeVisibilityHook) { try { removeVisibilityHook(); } catch (_) {} }
          window.analyzify.log(err, 'an_analyzify', 'analyzify_updateCartAttributes');
          return;
        }
      }
    } catch (error) {
      // Final catch-all (unexpected exception outside per-attempt handling)
      if (typeof window.analyzify.ssCartUpdateFailureEvent === 'function') {
        window.analyzify.ssCartUpdateFailureEvent({
          request_url_path: requestUrlPath || '/cart/update.js?app=azfy',
          method: method || 'POST',
          body_size_bytes: bodySizeBytes,
          attempt_number: 1,
          timeout_ms: timeoutMs || null,
          status_code: 0,
          error_category: 'exception',
          error_message_sanitized: error && error.message ? String(error.message) : 'Unexpected error in updateCartAttributes',
          duration_ms: 0,
          http_message: 'EXCEPTION',
          status_text: '',
          response_url: null,
          response_type: null,
          response_redirected: null,
          response_headers_cf_ray: null,
          response_headers_server: null,
          response_headers_via: null,
          response_headers_cf_cache_status: null,
          response_headers_content_type: null,
          response_body_excerpt: '',
          original_consent: requestTimeConsent,
          transport: 'exception',
          session_id: (window.analyzify.getFromLocalStorage && window.analyzify.getFromLocalStorage('sessionId')) || null,
          reason_code: 'exception',
          error_name: (error && error.name) ? String(error.name) : null,
          did_timeout: false,
          beacon_attempted: false
        });
      }
      window.analyzify.log(error, 'an_analyzify', 'analyzify_updateCartAttributes');
    }
  };

  // Wrapper function that queues updateCartAttributes calls too
  window.analyzify_updateCartAttributes = async function (attributes) {
    const wasQueued = window.analyzify_networkCartTracker.queueChecksendcartdata(() => {
      originalUpdateCartAttributes(attributes);
    });
    
    if (!wasQueued) {
      // No active requests, execute immediately
      window.analyzify.log('🟢 No active cart requests - executing updateCartAttributes immediately', 'an_analyzify', 'updateCartAttributes');
      return await originalUpdateCartAttributes(attributes);
    } else {
      window.analyzify.log('🟡 Cart request detected - updateCartAttributes queued for later execution', 'an_analyzify', 'updateCartAttributes');
    }
  };

  // Smart cart operation conflict prevention - proactive monitoring
  window.analyzify_networkCartTracker = {
    activeRequests: new Map(),
    pendingChecksendcartdata: [],
    isMonitoring: false,
    originalFetch: null,
    originalXHR: null,
    monitoringTimeout: null,
    
    // Start monitoring proactively on page load for cart pages
    init: function() {
      // Only monitor on pages where cart operations are likely
      const isCartPage = window.location.pathname.includes('cart') || 
                         document.querySelector('[data-product-form]') ||
                         document.querySelector('.product-form') ||
                         window.analyzify?.shopify_template === 'product';
      
      if (isCartPage) {
        this.startMonitoring();
      }
    },
    
    startMonitoring: function() {
      if (this.isMonitoring) return;
      
      this.isMonitoring = true;
      window.analyzify.log('🔍 Starting cart operation monitoring', 'an_analyzify', 'networkCartTracker');
      
      // Clear any existing timeout
      if (this.monitoringTimeout) {
        clearTimeout(this.monitoringTimeout);
      }
      
      // Store originals
      this.originalFetch = window.fetch;
      const originalXHR = window.XMLHttpRequest;
      this.originalXHR = originalXHR;
      
      // Override fetch
      window.fetch = (...args) => {
        const url = args[0];
        if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/change.js'))) {
          const requestId = `fetch_${Date.now()}`;
          this.addRequest(requestId, url);
          
          return this.originalFetch.apply(window, args)
            .then(response => {
              setTimeout(() => this.removeRequest(requestId), 600);
              return response;
            })
            .catch(error => {
              this.removeRequest(requestId);
              throw error;
            });
        }
        return this.originalFetch.apply(window, args);
      };
      
      // Override XMLHttpRequest
      window.XMLHttpRequest = function() {
        const xhr = new originalXHR();
        const originalOpen = xhr.open;
        
        xhr.open = function(method, url, ...args) {
          if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/change.js'))) {
            const requestId = `xhr_${Date.now()}`;
            window.analyzify_networkCartTracker.addRequest(requestId, url);
            
            xhr.addEventListener('loadend', () => {
              setTimeout(() => window.analyzify_networkCartTracker.removeRequest(requestId), 600);
            });
          }
          return originalOpen.apply(this, [method, url, ...args]);
        };
        return xhr;
      };
      
      // Monitor jQuery AJAX
      if (typeof $ !== 'undefined') {
        $(document).off('ajaxSend.analyzify').on('ajaxSend.analyzify', (event, xhr, settings) => {
          if (settings.url && (settings.url.includes('/cart/add.js') || settings.url.includes('/cart/change.js'))) {
            const requestId = `jquery_${Date.now()}`;
            this.addRequest(requestId, settings.url);
            xhr._analyzify_requestId = requestId;
          }
        });
        
        $(document).off('ajaxComplete.analyzify').on('ajaxComplete.analyzify', (event, xhr) => {
          if (xhr._analyzify_requestId) {
            setTimeout(() => this.removeRequest(xhr._analyzify_requestId), 600);
          }
        });
      }
      
      // Auto-stop monitoring after 60 seconds of inactivity (longer timeout)
      this.monitoringTimeout = setTimeout(() => this.stopMonitoring(), 60000);
    },
    
    stopMonitoring: function() {
      if (!this.isMonitoring) return;
      
      this.isMonitoring = false;
      window.analyzify.log('🛑 Stopping cart operation monitoring', 'an_analyzify', 'networkCartTracker');
      
      // Clear timeout
      if (this.monitoringTimeout) {
        clearTimeout(this.monitoringTimeout);
        this.monitoringTimeout = null;
      }
      
      // Restore originals
      if (this.originalFetch) {
        window.fetch = this.originalFetch;
        this.originalFetch = null;
      }
      
      if (this.originalXHR) {
        window.XMLHttpRequest = this.originalXHR;
        this.originalXHR = null;
      }
      
      // Remove jQuery listeners
      if (typeof $ !== 'undefined') {
        $(document).off('ajaxSend.analyzify ajaxComplete.analyzify');
      }
      
      // Clear any pending requests and process queue
      this.activeRequests.clear();
      this.processQueue();
    },
    
    addRequest: function(requestId, url) {
      this.activeRequests.set(requestId, Date.now());
      // Auto-cleanup after 8 seconds
      setTimeout(() => this.removeRequest(requestId), 8000);
    },
    
    removeRequest: function(requestId) {
      if (this.activeRequests.has(requestId)) {
        this.activeRequests.delete(requestId);
        // Process queue after request completes
        setTimeout(() => this.processQueue(), 200);
      }
    },
    
    hasActiveRequests: function() {
      return this.activeRequests.size > 0;
    },
    
    queueChecksendcartdata: function(func) {
      // Ensure monitoring is active
      if (!this.isMonitoring) {
        this.startMonitoring();
      }
      
      if (this.hasActiveRequests()) {
        this.pendingChecksendcartdata.push(func);
        return true;
      }
      return false;
    },
    
    processQueue: function() {
      if (this.pendingChecksendcartdata.length > 0 && !this.hasActiveRequests()) {
        const queue = this.pendingChecksendcartdata.splice(0);
        
        queue.forEach((func, index) => {
          setTimeout(func, index * 300);
        });
        
        // Reset timeout after processing queue
        if (this.isMonitoring) {
          if (this.monitoringTimeout) clearTimeout(this.monitoringTimeout);
          this.monitoringTimeout = setTimeout(() => this.stopMonitoring(), 30000);
        }
      }
    }
  };

  // Initialize monitoring on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.analyzify_networkCartTracker.init();
    });
  } else {
    window.analyzify_networkCartTracker.init();
  }

  // Store original function to avoid infinite recursion
  const originalChecksendcartdata = async function () {
    try{
      if(window.analyzify.checksendcartdata_status == false && window.analyzify.op_cart_data_collection){
        const isValid = (id) => {
          const valid = id && id !== "null" && id !== "undefined" && id.startsWith('G-');
          return valid;
        };
        
        const measurementId = window.analyzify?.properties?.SERVERSIDE?.measurement_id;
        
        const cartData = await window.collectCartData(measurementId);

        const updateCartWithTimeout = async (measurementId) => {

          const cartData = await window.collectCartData(measurementId);

          if (cartData && Object.keys(cartData).length) {
            
            setTimeout(async () => {
              
              try {
                await window.analyzify_updateCartAttributes(cartData);
                window.analyzify.log('✅ Cart attributes updated via queued execution', 'an_analyzify', 'checksendcartdata');
              } catch (error) {
                window.analyzify.log('❌ checksendcartdata: Failed to update cart attributes: ' + error, 'an_analyzify', 'checksendcartdata');
              }
            }, 300); // Minimal delay since we already waited
          } else {
            window.analyzify.log("⚠️ checksendcartdata: No cart data to update or empty cart data", 'an_analyzify', 'checksendcartdata');
          }
        };
        
        updateCartWithTimeout(measurementId);

        return cartData;
      } else {
        window.analyzify.log("❌ checksendcartdata: Conditions not met - skipping execution", 'an_analyzify', 'checksendcartdata');
        window.analyzify.log("❌ checksendcartdata: checksendcartdata_status = " + window.analyzify.checksendcartdata_status, 'an_analyzify', 'checksendcartdata');
        window.analyzify.log("❌ checksendcartdata: op_cart_data_collection = " + window.analyzify.op_cart_data_collection, 'an_analyzify', 'checksendcartdata');
      }
    } catch(error) {
      window.analyzify.log("❌ checksendcartdata: Error in function: " + error, 'an_analyzify', 'checksendcartdata');
      window.analyzify.log(error, 'an_analyzify', 'analyzify_checksendcartdata');
    }
  };

  // Simplified wrapper - only activates monitoring when needed
  window.analyzify_checksendcartdata = async function () {
    const wasQueued = window.analyzify_networkCartTracker.queueChecksendcartdata(() => {
      originalChecksendcartdata();
    });
    
    if (!wasQueued) {
      return await originalChecksendcartdata();
    }
  };

  // ============================================================================
  // CART UPSERT MODULE (Lite)
  // Bolt-on module — does NOT modify any existing function.
  // Reads from window.analyzify.cart_attributes, transforms legacy → attribution
  // format, hash-checks for changes, and POSTs cart_upsert to server.
  // Kill switch: SERVERSIDE.cart_upsert must be true.
  // ============================================================================

  /**
   * Transforms legacy cart_attributes format to the attribution format
   * expected by the cart_upsert endpoint.
   *
   * Legacy clids/cookies: ["prefix:value", ...] → {prefix: "value", ...}
   * Legacy utm_history: {"timestamp": ["prefix:value", ...]} or {"timestamp": {values: [...], cartId: "x"}}
   *   → [{timestamp: Number, src: "...", med: "...", cartId: "x"}, ...]
   */
  window.analyzify.transformToUpsertFormat = function () {
    // Read from session storage — stable source that persists across the
    // double-collectCartData race condition in checksendcartdata.
    var ss = window.analyzify.sessionStorage;

    var rawClids = null, rawCookies = null, rawUtmHistory = null, rawConsent = null;
    try { var s = ss.get('azfy_clids'); if (s) rawClids = JSON.parse(s); } catch (_e) {}
    try { var s2 = ss.get('azfy_cookies'); if (s2) rawCookies = JSON.parse(s2); } catch (_e) {}
    try { var s3 = ss.get('azfy_utm_history'); if (s3) rawUtmHistory = JSON.parse(s3); } catch (_e) {}
    try {
      var consentStr = ss.get('azfy_consent');
      if (consentStr === 'true') rawConsent = true;
      else if (consentStr === 'false') rawConsent = false;
      else if (consentStr) rawConsent = consentStr;
    } catch (_e) {}

    // Helper: prefixed array ["g:abc", "fb:xyz"] → object {g: "abc", fb: "xyz"}
    var prefixedArrayToObject = function (arr) {
      if (!Array.isArray(arr) || !arr.length) return null;
      var obj = {};
      arr.forEach(function (item) {
        if (typeof item === 'string' && item.includes(':')) {
          var parts = item.split(':');
          var prefix = parts[0];
          var value = parts.slice(1).join(':');
          if (prefix && value) obj[prefix] = value;
        }
      });
      return Object.keys(obj).length > 0 ? obj : null;
    };

    var clids = prefixedArrayToObject(rawClids);
    var cookies = prefixedArrayToObject(rawCookies);

    // Transform utm_history: keyed object → array of objects
    // {"1234567890": {values: ["src:google"], cartId: "x"}} → [{timestamp: 1234567890, src: "google", cartId: "x"}]
    var utmHistory = null;
    if (rawUtmHistory && typeof rawUtmHistory === 'object' && !Array.isArray(rawUtmHistory)) {
      var keyMap = { src: "src", med: "med", camp: "camp", cont: "cont", term: "term", id: "id", ref: "ref", pid: "pid" };
      utmHistory = [];
      Object.keys(rawUtmHistory)
        .sort(function (a, b) { return parseInt(a) - parseInt(b); })
        .forEach(function (timestamp) {
          var entry = rawUtmHistory[timestamp];
          var values = Array.isArray(entry) ? entry : (entry && entry.values ? entry.values : []);
          var cartId = (entry && entry.cartId) ? entry.cartId : null;
          var obj = { timestamp: Number(timestamp) || parseInt(timestamp, 10) || null };
          if (Array.isArray(values)) {
            values.forEach(function (token) {
              var parts = String(token || "").split(":");
              var p = parts[0]; var v = parts.slice(1).join(":");
              var mapped = keyMap[p];
              if (mapped && v !== undefined && v !== null && v !== "") obj[mapped] = v;
            });
          }
          if (cartId) obj.cartId = cartId;
          utmHistory.push(obj);
        });
      if (utmHistory.length === 0) utmHistory = null;
    }

    // Consent: use stored value or derive from current state
    var consent = rawConsent;
    if (consent === undefined || consent === null) {
      consent = !window.analyzify.consent_active ||
        (window.analyzify.current_consent?.ad_storage === "granted" &&
          window.analyzify.current_consent?.analytics_storage === "granted");
    }

    // Save transformed data to _atr session storage keys so serversidecustompixel.js
    // can read attribution-format data during checkout events
    try {
      if (clids) ss.save('azfy_clids_atr', JSON.stringify(clids));
      if (cookies) ss.save('azfy_cookies_atr', JSON.stringify(cookies));
      if (utmHistory) ss.save('azfy_utm_history_atr', JSON.stringify(utmHistory));
    } catch (_e) {}

    return {
      azfy_utm_history: utmHistory,
      azfy_clids: clids,
      azfy_cookies: cookies,
      azfy_consent: consent
    };
  };

  /**
   * Validates and POSTs cart_upsert event to the server-side endpoint.
   * Validation logic matches main extension (v4.3.51).
   */
  window.analyzify.ssCartUpsertEvent = async function (cartAttributes) {
    try {
      const endpoint = window.analyzify.properties?.SERVERSIDE?.endpoint;
      if (!endpoint) {
        return window.analyzify.log('Endpoint not found for cart_upsert', 'an_analyzify', 'ssCartUpsertEvent');
      }

      window.analyzify.log("Sending cart_upsert event", "an_analyzify", "ssCartUpsertEvent");
      window.analyzify.log(cartAttributes, "an_analyzify", "ssCartUpsertEvent");

      // Separate cart_id (goes in userData.eventId, not in attributes)
      // Use destructuring to avoid mutating the caller's object
      const { azfy_cart_id, ...filteredCartAttributes } = cartAttributes;

      // Normalize consent
      if (filteredCartAttributes.azfy_consent !== undefined) {
        filteredCartAttributes.azfy_consent = filteredCartAttributes.azfy_consent === "true" || filteredCartAttributes.azfy_consent === true;
      }

      // Filter cookies if consent denied
      if (!filteredCartAttributes.azfy_consent) {
        delete filteredCartAttributes.azfy_cookies;
        window.analyzify.log("Consent denied: filtered out azfy_cookies from cart_upsert payload", "an_analyzify", "ssCartUpsertEvent");
      }

      // Validate azfy_utm_history
      if (filteredCartAttributes.azfy_utm_history !== undefined && filteredCartAttributes.azfy_utm_history !== null) {
        const uh = filteredCartAttributes.azfy_utm_history;
        if (!Array.isArray(uh)) {
          window.analyzify.log('azfy_utm_history validation failed: expected array, got ' + typeof uh, 'an_analyzify', 'ssCartUpsertEvent');
          return;
        }
        const allowedKeys = new Set(["timestamp","src","med","camp","cont","term","id","ref","pid","cartId"]);
        for (let i = 0; i < uh.length; i++) {
          const entry = uh[i];
          if (!entry || typeof entry !== 'object' || Array.isArray(entry)) {
            window.analyzify.log('azfy_utm_history entry must be an object', 'an_analyzify', 'ssCartUpsertEvent');
            return;
          }
          if (typeof entry.timestamp !== 'number' || !isFinite(entry.timestamp)) {
            window.analyzify.log('azfy_utm_history entry.timestamp must be number', 'an_analyzify', 'ssCartUpsertEvent');
            return;
          }
          for (const k in entry) {
            if (!allowedKeys.has(k)) {
              window.analyzify.log('azfy_utm_history entry has unsupported key: ' + k, 'an_analyzify', 'ssCartUpsertEvent');
              return;
            }
            if (k !== 'timestamp' && k !== 'cartId' && entry[k] != null && typeof entry[k] !== 'string') {
              window.analyzify.log('azfy_utm_history entry field ' + k + ' must be string', 'an_analyzify', 'ssCartUpsertEvent');
              return;
            }
          }
        }
      }

      // Validate azfy_clids
      if (filteredCartAttributes.azfy_clids !== undefined && filteredCartAttributes.azfy_clids !== null) {
        const cl = filteredCartAttributes.azfy_clids;
        if (typeof cl !== 'object' || Array.isArray(cl)) {
          window.analyzify.log('azfy_clids must be an object', 'an_analyzify', 'ssCartUpsertEvent');
          return;
        }
        for (const ck in cl) {
          if (cl[ck] != null && typeof cl[ck] !== 'string') {
            window.analyzify.log('azfy_clids.' + ck + ' must be string', 'an_analyzify', 'ssCartUpsertEvent');
            return;
          }
        }
      }

      // Validate azfy_cookies
      if (filteredCartAttributes.azfy_cookies !== undefined && filteredCartAttributes.azfy_cookies !== null) {
        const co = filteredCartAttributes.azfy_cookies;
        if (typeof co !== 'object' || Array.isArray(co)) {
          window.analyzify.log('azfy_cookies must be an object', 'an_analyzify', 'ssCartUpsertEvent');
          return;
        }
        for (const cok in co) {
          if (co[cok] != null && typeof co[cok] !== 'string') {
            window.analyzify.log('azfy_cookies.' + cok + ' must be string', 'an_analyzify', 'ssCartUpsertEvent');
            return;
          }
        }
      }

      const payload = {
        eventName: "cart_upsert",
        userData: {
          eventId: window.analyzify.cart_id || azfy_cart_id || null,
          id: window.analyzify.properties?.SERVERSIDE?.store_id || null,
          azfy_consent: filteredCartAttributes.azfy_consent,
        },
        attributes: filteredCartAttributes
      };

      window.analyzify.log('cart_upsert payload:', 'an_analyzify', 'ssCartUpsertEvent');
      window.analyzify.log(payload, 'an_analyzify', 'ssCartUpsertEvent');

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('HTTP error! status: ' + response.status);
      }

      window.analyzify.log("Cart upsert event sent successfully", "an_analyzify", "ssCartUpsertEvent");
    } catch (error) {
      window.analyzify.log('Error sending cart_upsert event: ' + error, 'an_analyzify', 'ssCartUpsertEvent');
    }
  };

  // --- Decorator: wrap checksendcartdata to trigger cart_upsert after it completes ---
  (function () {
    if (!window.analyzify.properties?.SERVERSIDE?.cart_upsert) {
      window.analyzify.log('Cart upsert disabled (SERVERSIDE.cart_upsert is not true)', 'an_analyzify', 'cartUpsertModule');
      return; // Kill switch — do nothing if not enabled
    }

    const _originalChecksendcartdata = window.analyzify_checksendcartdata;

    window.analyzify_checksendcartdata = async function () {
      // Run original first — this populates session storage via collectCartData
      const result = await _originalChecksendcartdata();

      // Transform session storage data → attribution format, save _atr keys, and send
      try {
        const upsertData = window.analyzify.transformToUpsertFormat();

        // Guard: skip if session storage had no meaningful attribution data
        if (!upsertData.azfy_utm_history && !upsertData.azfy_clids && !upsertData.azfy_cookies) {
          window.analyzify.log('No attribution data in session storage, skipping cart_upsert', 'an_analyzify', 'cartUpsertModule');
          return result;
        }

        // Add cart_id for the eventId field
        upsertData.azfy_cart_id = window.analyzify.getCartId();

        // Hash-check: only send if data has actually changed
        const consentValue = upsertData.azfy_consent;
        const hasConsent = consentValue === "true" || consentValue === true;
        const skipKeys = hasConsent ? [] : ['azfy_cookies'];

        const detection = window.analyzify.detectChangesByHash(upsertData, {
          namespace: 'upsert',
          skipKeys: skipKeys,
          ignoreRemovedKeys: true
        });

        if (detection.hasChanges) {
          if (!window.analyzify.properties?.SERVERSIDE?.store_id) {
            window.analyzify.log('Store ID not found, skipping cart_upsert', 'an_analyzify', 'cartUpsertModule');
          } else {
            await window.analyzify.ssCartUpsertEvent(upsertData);
          }
        } else {
          window.analyzify.log('No cart attribute changes detected, cart_upsert not sent', 'an_analyzify', 'cartUpsertModule');
        }
      } catch (error) {
        window.analyzify.log('Cart upsert module error: ' + error, 'an_analyzify', 'cartUpsertModule');
      }

      return result;
    };

    window.analyzify.log('Cart upsert module initialized (decorator active)', 'an_analyzify', 'cartUpsertModule');
  })();

  // ============================================================================
  // VARIANT CHANGE EVENT FUNCTIONALITY
  // ============================================================================
  
  // Initialize variant change tracking when the page is ready
  window.analyzify.initVariantChangeTracking = () => {
    try {
      analyzify.log('Initializing variant change tracking', 'an_analyzify', 'initVariantChangeTracking');
      
      if (window.analyzify.shopify_template !== 'product') {
        analyzify.log('Not a product page, skipping variant change tracking', 'an_analyzify', 'initVariantChangeTracking');
        return;
      }

      setTimeout(() => {
        try {
          const variantSelectors = window.analyzify.attributes?.variant_options?.class || [
            "variant-radios", 
            "variant-picker", 
            ".product-form__input", 
            ".variant-selects", 
            ".product-form__variants"
          ];

          const allPossibleSelectors = [
            'select[name*="variant"]',
            'input[name*="variant"]',
            '[data-variant]',
            '.variant',
            '.product-form__input',
            '.product-form__variants',
            'form[data-product-form]',
            '[data-product-form]'
          ];
          
          allPossibleSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
              window.analyzify.log(`GTMVARIANT: Found ${elements.length} elements with selector "${selector}": ${elements.length} elements`, 'an_analyzify', 'initVariantChangeTracking');
            }
          });
          
          const forms = document.querySelectorAll('form');
          forms.forEach((form, index) => {
            const formInputs = form.querySelectorAll('input, select');
          });
          
          const getVariantOptions = document.querySelector(variantSelectors.join(","));
          analyzify.log('getVariantOptions element:', getVariantOptions, 'an_analyzify', 'initVariantChangeTracking');
      
          if (getVariantOptions !== null) {
            
            // Add debounce to prevent multiple rapid calls
            let lastCallTime = 0;
            const DEBOUNCE_DELAY = 100; // milliseconds
            let currentVariantId = window.analyzify.getCurrentVariant()?.id;
            let firstRun = false;
            analyzify.log('currentVariantId in initVariantChangeTracking', currentVariantId, 'an_analyzify', 'initVariantChangeTracking');

            window.analyzify.handleVariantChange = (source) => {
              try {
                analyzify.log('handleVariantChange triggered by:', source, 'an_analyzify', 'initVariantChangeTracking');
            
                const now = Date.now();
                if (now - lastCallTime < DEBOUNCE_DELAY) {
                  analyzify.log('Skipping call due to debounce; too soon after last call.', 'an_analyzify', 'initVariantChangeTracking');
                  return;
                }
                lastCallTime = now;
            
                const variantData = window.analyzify.getCurrentVariant();
                
                if (!variantData?.id) {
                  analyzify.log('Variant ID not found in variantData.', 'an_analyzify', 'handleVariantChange');
                  return;
                }
            
                analyzify.log('Current variantData ID:', variantData.id, '| Previously processed currentVariantId:', currentVariantId, 'an_analyzify', 'handleVariantChange');
            

                if (variantData.id === currentVariantId) {
                  analyzify.log('Variant ID is the same as the current. No new change to process.', 'an_analyzify', 'handleVariantChange');
                  return;
                }
            
                currentVariantId = variantData.id;
                analyzify.log('New variant ID detected. Updating currentVariantId to:', currentVariantId, 'an_analyzify', 'handleVariantChange');
            
                
                if (typeof window.analyzify.gtmVariantChange === 'function') {
                  window.analyzify.gtmVariantChange(variantData);
                } else {
                  analyzify.log('gtmVariantChange function not available.', 'an_analyzify', 'handleVariantChange');
                }
            
                analyzify.log(`Variant change processed successfully from ${source}. New variant ID: ${currentVariantId}`, 'an_analyzify', 'handleVariantChange');
                analyzify.log('Variant data:', variantData, 'an_analyzify', 'handleVariantChange');
            
              } catch (error) {
                console.error("Error processing variant change in handleVariantChange:", error);
              }
            };
        
            getVariantOptions.addEventListener("change", () => {
              try {
                window.analyzify.handleVariantChange('DOM change');
                analyzify.log('Variant changed from DOM change', 'an_analyzify', 'initVariantChangeTracking');
              } catch (error) {
                console.error("Error processing variant change:", error);
              }
            });
                
            window.addEventListener('popstate', () => {
              try {
                window.analyzify.handleVariantChange('URL change');
                analyzify.log('Variant changed from URL change', 'an_analyzify', 'initVariantChangeTracking');
              } catch (error) {
                console.error("Error processing variant change:", error);
              }
            });
                
            const originalPushState = history.pushState;
            history.pushState = function() {
              try {
                originalPushState.apply(this, arguments);
                window.analyzify.handleVariantChange('pushState');
                analyzify.log('Variant changed from pushState', 'an_analyzify', 'initVariantChangeTracking');
              } catch (error) {
                console.error("Error processing variant change:", error);
              }
            };
      
            const originalReplaceState = history.replaceState;
            history.replaceState = function() {
              try {
                originalReplaceState.apply(this, arguments);
                window.analyzify.handleVariantChange('replaceState');
                analyzify.log('Variant changed from replaceState', 'an_analyzify', 'initVariantChangeTracking');
              } catch (error) {
                console.error("Error processing variant change:", error);
              }
            };
                  
          } else {
            analyzify.log('getVariantOptions not found', 'an_analyzify', 'initVariantChangeTracking');
            
            document.addEventListener('variantChanged', (event) => {
              try {
                const variant = event.detail || event;
                if (variant && window.analyzify.handleVariantChange) {
                  window.analyzify.handleVariantChange('variantChanged event');
                }
              } catch (error) {
                console.error('GTMVARIANT: Error handling variantChanged event:', error);
              }
            });
            
            if (typeof $ !== 'undefined') {
              $(document).on('variantChanged', (event, variant) => {
                try {
                  if (window.analyzify.handleVariantChange) {
                    window.analyzify.handleVariantChange('jQuery variantChanged event');
                  }
                } catch (error) {
                }
              });
              
              $(window).on('cc-variant-updated', (event, args) => {
                try {
                  if (args && args.variant && window.analyzify.handleVariantChange) {
                    window.analyzify.handleVariantChange('cc-variant-updated event');
                  }
                } catch (error) {
                  console.error('GTMVARIANT: Error handling cc-variant-updated event:', error);
                }
              });
            }
          }

        } catch (error) {
          console.error("Error setting up variant change tracking:", error);
        }
      }, 2000); 

    } catch (error) {
      console.error("Error in initVariantChangeTracking:", error);
    }
  };

  // Cart monitoring and update functions - moved from settings
  window.analyzify.updateDetectedCart = async function() {
    try {
      await new Promise(resolve => setTimeout(resolve, 1600));
      const response = await fetch('/cart.js');
      const cart = await response.json();
      window.analyzify.detectedCart = cart;
      window.analyzify.log("cart updated: " + JSON.stringify(cart), 'an_analyzify', 'updateDetectedCart');
      
      // Check if recently added variant is in cart (if validation is enabled)
      if (window.analyzify.lastAddedVariant && 
          window.analyzify.gtmCartValidationFailed && 
          window.analyzify?.properties?.GTM?.enableAtcCartValidationEvent !== false) {
        const variantInfo = window.analyzify.lastAddedVariant;
        const productTitle = variantInfo.productTitle;
        
        // Only check if the add was recent (within last 10 seconds)
        const isRecent = (Date.now() - variantInfo.timestamp) < 10000;
        
        if (isRecent && productTitle) {
          const productInCart = cart.items?.some(item => 
            (item.product_title || item.title) === productTitle
          );
          
          if (!productInCart) {
            window.analyzify.gtmCartValidationFailed(variantInfo, cart);
          } else {
            analyzify.log(`Cart validation passed - product "${productTitle}" found in cart`, 'an_analyzify', 'updateDetectedCart');
          }
        }
        
        // Clear the stored variant info after check
        window.analyzify.lastAddedVariant = null;
      }
      
    } catch (error) {
      analyzify.log("Cart update error", 'an_analyzify', 'updateDetectedCart');
    }
  };

  // Cart watcher - moved from settings
  window.analyzify.initCartWatcher = function() {
    // Only run on wishlist page
    if (!window.location.pathname.includes('/pages/your-wishlist')) return;
    
    let lastCart = window.analyzify.detectedCart;
    const buildQtyMap = (cart) => {
      const map = new Map();
      (cart?.items || []).forEach(it => map.set(String(it.variant_id), Number(it.quantity) || 0));
      return map;
    };
    let lastMap = buildQtyMap(lastCart);

    setInterval(async () => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const newMap = buildQtyMap(cart);

        let bestDelta = 0;
        let bestVariantId = null;
        newMap.forEach((qty, key) => {
          const prev = lastMap.get(key) || 0;
          const delta = qty - prev;
          if (delta > bestDelta) { bestDelta = delta; bestVariantId = key; }
        });

        const changed = JSON.stringify(lastCart?.items || []) !== JSON.stringify(cart?.items || []);
        if (changed) {
          const lastAdded = bestVariantId ? (cart.items.find(it => String(it.variant_id) === String(bestVariantId)) || null) : null;
          window.analyzify.lastAddedCartItem = lastAdded;
          window.analyzify.detectedCart = cart;
          lastCart = cart;
          lastMap = newMap;
        }
      } catch (error) {
        analyzify.log("Cart watcher error", 'an_analyzify', 'initCartWatcher');
      }
    }, 1500);
  };

  // Initialize cart watcher when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.analyzify.initCartWatcher();
    });
  } else {
    window.analyzify.initCartWatcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.analyzify.initVariantChangeTracking();
    });
  } else {
    window.analyzify.initVariantChangeTracking();
  }

  analyzify.log(`Analyzify ${window?.analyzify?.analyzify_version} is ready.`, 'an_analyzify_settings');
  window.analyzify.initial_load.an_analyzify = true;

  //used for making sure data is populated before being sent to update.js and analyzifycdn on first page render.
  const consentHandler = (e) => {
    try {
      let retries = 0;
      const maxRetries = 5;
      const retryDelay = 800; 
      
      const checkTtpAndExecute = () => {
        window.analyzify.cart_id = window.analyzify?.cookieStorage.get('cart')?.split('?')[0] || null;
        
        const ttpCookie = document.cookie.split('; ').find(row => row.startsWith('_ttp='));
        const fbpCookie = document.cookie.split('; ').find(row => row.startsWith('_fbp='));
        const fbcCookie = document.cookie.split('; ').find(row => row.startsWith('_fbc='));

        if (ttpCookie && fbpCookie && fbcCookie && window.analyzify.cart_id) {
          if (typeof window.analyzify_checksendcartdata === 'function') {
            window.analyzify_checksendcartdata();
          } else {
            window.analyzify.log("analyzify_checksendcartdata function not found");
          }
        } else if (retries < maxRetries) {
          retries++;
          setTimeout(checkTtpAndExecute, retryDelay);
        } else {
          if (typeof window.analyzify_checksendcartdata === 'function') {
            window.analyzify_checksendcartdata();
          } else {
            window.analyzify.log("analyzify_checksendcartdata function not found");
          }
        }
      };
      
      checkTtpAndExecute();
    } catch (error) {
      console.error("Error processing consent changes:", error);
    }
  };

  consentHandler()
} catch(error) {
  console.error('Analyzify initialization error:', error);
}
